import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Printer = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M15.334 12.982H12a.333.333 0 1 1 0-.666h3v-4a2.669 2.669 0 0 0-2.666-2.667H3.667a2.667 2.667 0 0 0-2.666 2.667v4h3a.333.333 0 1 1 0 .666H.667a.333.333 0 0 1-.333-.333V8.316a3.333 3.333 0 0 1 3.333-3.334h8.667a3.337 3.337 0 0 1 3.333 3.334v4.333a.333.333 0 0 1-.333.333Z" />
      <path d="M11.834 7.982a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM12.001 3.982a.333.333 0 0 1-.333-.334V2.315H4.335v1.333a.333.333 0 0 1-.667 0V1.982a.333.333 0 0 1 .333-.334h8a.333.333 0 0 1 .334.334v1.666a.333.333 0 0 1-.334.334ZM4.001 9.314h8a.333.333 0 0 1 .334.334v6.333a.333.333 0 0 1-.334.333h-8a.333.333 0 0 1-.333-.333V9.648a.333.333 0 0 1 .333-.334Zm7.667.667H4.335v5.667h7.333V9.98Z" />
      <path d="M10.001 11.981h-4a.333.333 0 1 1 0-.666h4a.333.333 0 1 1 0 .666ZM10.001 14.315h-4a.333.333 0 1 1 0-.667h4a.333.333 0 0 1 0 .667Z" />
    </svg>
  );
};

Printer.category = 'product-category';

Printer.displayName = 'Printer';
